import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DocumentScoringGridComponentAlpha from './DocumentScoringGridComponentAlpha';
import { updateScoringFileWithAccountStatementDataInProgress, updateFinancialIndicatorDimensions } from '../actionCreators';

export const DocumentScoringGridContainerAlpha = ({
  scoringGrid,
  disabled,
  documentId,
  siteId,
  rights,
  isHistory,
  dimensionPeriods,
  actions
}) => {
  const [state, setState] = useState({
    showModal: false,
    savingModal: false,
    loading: false,
    saving: false,
    acordionExpanded: true
  });

  const onImportFinancialIndicators = async () => {
    setState({
      ...state,
      saving: true
    });

    try {
      const event = await actions.updateScoringFileWithAccountStatementDataInProgress(documentId, siteId);
      if (event.ok) {
        setState({
          ...state,
          saving: false
        });
      } else {
        setState({ ...state, saving: false });
      }
    } catch (error) {
      setState({ ...state, saving: false });
    }
  };

  const onOpenDimensionListModal = () => {
    setState({
      ...state,
      showModal: true
    });
  };

  const onCloseDimensionListModal = () => {
    setState({
      ...state,
      showModal: false
    });
  };

  const onAcordionChange = (_, expanded) => {
    setState({
      ...state,
      acordionExpanded: expanded
    });
  };

  const onSavePeriodDimensions = async newPeriodDimensions => {
    setState({
      ...state,
      savingModal: true
    });
    const validPeriodDimensions = newPeriodDimensions.filter(x => x.dimensionPeriodMonth && x.dimensionPeriodYear && x.dimensionId);
    const byYearAndMonth = (x, y) => y.dimensionPeriodYear - x.dimensionPeriodYear || y.dimensionPeriodMonth - x.dimensionPeriodMonth;
    const newPeriodList = validPeriodDimensions.sort(byYearAndMonth);
    const classificationWithIndicators = scoringGrid.classifications.find(x => x.financialIndicators.length > 0);
    try {
      const event = await actions.updateFinancialIndicatorDimensions(
        documentId,
        siteId,
        scoringGrid.documentScoringGridId,
        scoringGrid.entityType,
        classificationWithIndicators?.scoringClassificationId,
        classificationWithIndicators?.financialIndicators,
        newPeriodList,
        scoringGrid.scoringGridId
      );
      if (event.ok) {
        setState({
          ...state,
          showModal: false,
          savingModal: false
        });
      } else {
        setState({
          ...state,
          savingModal: false
        });
      }
    } catch (error) {
      setState({
        ...state,
        savingModal: false
      });
    }
  };

  return (
    <DocumentScoringGridComponentAlpha
      documentId={documentId}
      siteId={siteId}
      scoringGrid={scoringGrid}
      isHistory={isHistory}
      dimensionPeriods={dimensionPeriods}
      rights={rights}
      disabled={disabled}
      showModal={state.showModal}
      savingModal={state.savingModal}
      savingIndicators={state.saving}
      onImportFinancialIndicators={onImportFinancialIndicators}
      onOpenDimensionListModal={onOpenDimensionListModal}
      onCloseDimensionListModal={onCloseDimensionListModal}
      onSavePeriodDimensions={onSavePeriodDimensions}
      onAcordionChange={onAcordionChange}
      acordionExpanded={state.acordionExpanded}
    />
  );
};

DocumentScoringGridContainerAlpha.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  scoringGrid: PropTypes.object.isRequired,
  rights: PropTypes.object.isRequired,
  isHistory: PropTypes.bool,
  dimensionPeriods: PropTypes.array,
  disabled: PropTypes.bool,
  actions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ updateScoringFileWithAccountStatementDataInProgress, updateFinancialIndicatorDimensions }, dispatch)
  };
}

export default compose(connect(null, mapDispatchToProps))(DocumentScoringGridContainerAlpha);
